<template>
  <div>
    <el-dialog
      center
      width="392px"
      class="confirm"
      :modal="true"
      :before-close="cancel"
      :visible.sync="isVisible"
      :close-on-click-modal="isClick">

      <!-- title -->
      <div class="title-msg">
        <span>{{ title }}</span>
      </div>

      <!-- content -->
      <div class="m-top-3">
        <pre class="confirm-msg">{{ msg }}</pre>
      </div>

      <!-- confirm-btn -->
      <div class="m-top-5 text-center confirm-btn">
        <sp-smart-button
          :class="isColor ? 'btn-color': ''"
          @click="ok">
          {{ $t("button.common.ok") }}
        </sp-smart-button>
      </div>

      <!-- cancel-btn -->
      <div class="m-top-2 text-center cancel-btn" v-if="isCancel == true">
        <cancel-narrow-down
          @click="cancel"
          class="link-primary">
          {{ $t("button.common.cancel") }}
        </cancel-narrow-down>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import SpSmartButton from "@/components/common/sp-smart-button"
import cancelNarrowDown from "@/components/common/generalButton/CancelNarrowDown"

export default {
  components:{
    SpSmartButton: SpSmartButton,
    cancelNarrowDown: cancelNarrowDown
  },
  data() {
    return {
      isVisible: this.visible,
      title: this.titleMsg,
      msg: this.contentMsg,
      isCancel: this.cancelFlag,
      isClick: this.clickFlag,
      isColor: this.colorFlag
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    titleMsg: {
      type: String,
      default: null,
    },
    contentMsg: {
      type: String,
      default: null
    },
    cancelFlag: {
      type: Boolean,
      default: true,
    },
    clickFlag: {
      type: Boolean,
      default: true,
    },
    colorFlag: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    visible(val) {
      this.isVisible = val
    },
    titleMsg(val) {
      this.title = val
    },
    contentMsg(val) {
      this.msg = val
    },
    cancelFlag(val) {
      this.isCancel = val
    }
  },
  mounted() {
  },
  methods: {

    cancel () {
      this.$emit("update:visible", false)
    },

    ok () {
      this.$emit("on-confirm")
      this.$emit("update:visible", false)
    }

  }
};
</script>

<style scoped lang="scss">
.confirm::v-deep {
  .el-dialog__header {
    display: none;
  }
}
.title-msg {
  font-size: 24px;
  color: #525250;
  text-align: center;
}
.confirm-msg {
  font-family: 'Hiragino Kaku Gothic ProN','ヒラギノ角ゴ ProN W3','メイリオ', 'Meiryo','ＭＳ ゴシック', sans-serif  !important;
  text-align: center;
  display: block;
  font-size: 14px;
  color: #525250;
}
.confirm-btn::v-deep {
  .my-button {
    width: 100%;
  }
}
.cancel-btn::v-deep {
  .glance-cancel-down {
    font-size: 11px;
  }
}

.btn-color {
  background-color: rgba(50, 156, 166, 1);
  color: rgba(255, 255, 255, 1);
}
</style>
